import axios from 'axios';

type GetTimeAvailabilityType = {
  listingId: string;
  dateStr: string;
  checkUnavailableDays?: boolean;
};

const getTimeAvailability = async ({
  listingId,
  dateStr,
  checkUnavailableDays,
}: GetTimeAvailabilityType) => {
  const { data } = await axios.get<Record<string, boolean>>(
    `/listing/${listingId}/appointments/times`,
    {
      params: {
        date: dateStr,
        checkUnavailableDays,
      },
    },
  );
  return data;
};

export default getTimeAvailability;
